import { render, staticRenderFns } from "./attorney-signed-disclosures.vue?vue&type=template&id=01f3c618"
import script from "./attorney-signed-disclosures.vue?vue&type=script&lang=js"
export * from "./attorney-signed-disclosures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports